
import makerjs from "makerjs";
function C06(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    R = Param[0].param,R1 = Param[1].param,D = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r = R * 1 * myZoom, 
       r1 = R1 * 1 * myZoom,
       d = D * 1 * myZoom,       
       h = 2*r,
       w = 2*r,
       rd1=r1/Math.sqrt(2),
       rd=r/Math.sqrt(2),
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       /**
        * sin60=Math.sqrt(3)/2
        * cos60=1/2
        * 
        */
hd=d*Math.sqrt(2)/2,
wd=d*Math.sqrt(2)/2,
       x=r,y=r,glassH = h, glassW = w;

       if (r !== 0) {
        var TxtR = "R="+R;
    }if (r1 !== 0) {
      var TxtR1 = "R1="+R1;
  } if (d !== 0) {
    var TxtD = "D="+D;
} 


   var drawAbnormalShapeC06 = {
       paths: {
        "holesOUp": new makerjs.paths.Arc([r, r], r, 180,0),
        "holesODn": new makerjs.paths.Arc([r, r], r, 0,180),
        "holesAUp": new makerjs.paths.Arc([r+d, r], r1, 180,0),
        "holesADn": new makerjs.paths.Arc([r+d, r], r1, 0,180),
        "holesBUp": new makerjs.paths.Arc([r, r+d], r1, 180,0),
        "holesBDn": new makerjs.paths.Arc([r, r+d], r1, 0,180),
        "holesCUp": new makerjs.paths.Arc([r-d, r], r1, 180,0),
        "holesCDn": new makerjs.paths.Arc([r-d, r], r1, 0,180),
        "holesDUp": new makerjs.paths.Arc([r, r-d], r1, 180,0),
        "holesDDn": new makerjs.paths.Arc([r, r-d], r1, 0,180),
    
       }
   };
   var drawAbnormalShapeC06MarkR = {
       paths: {
        "LeftLine": new makerjs.paths.Line([r, r], [r+rd, r+rd]),
       }
   };
   var drawAbnormalShapeC06MarkD = {
       paths: {
        "LeftLine": new makerjs.paths.Line([r, r], [r+d, r]),
       }
   };
   var drawAbnormalShapeC06MarkR1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([r-d, r], [r-d+r1, r]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeC06MarkR, TxtR, [r+rd, r+rd+markShift], [r+rd+3*markShift, r+rd+markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC06MarkD, TxtD, [r, r+2*markShift], [r+d, r+2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC06MarkR1, TxtR1, [r-d, r+2*markShift], [r-d+r1, r+2*markShift]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeC06: drawAbnormalShapeC06,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC06: drawAbnormalShapeC06,
        drawAbnormalShapeC06MarkR: drawAbnormalShapeC06MarkR,
        drawAbnormalShapeC06MarkD: drawAbnormalShapeC06MarkD,
        drawAbnormalShapeC06MarkR1: drawAbnormalShapeC06MarkR1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C06;